import { render, staticRenderFns } from "./Passo4.vue?vue&type=template&id=739537e4&scoped=true&"
import script from "./Passo4.vue?vue&type=script&lang=js&"
export * from "./Passo4.vue?vue&type=script&lang=js&"
import style0 from "./Passo4.vue?vue&type=style&index=0&id=739537e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "739537e4",
  null
  
)

export default component.exports